import { render, staticRenderFns } from "./direct-sales-historic-client.page.vue?vue&type=template&id=57342dfe&scoped=true"
import script from "./direct-sales-historic-client.page.vue?vue&type=script&lang=ts"
export * from "./direct-sales-historic-client.page.vue?vue&type=script&lang=ts"
import style0 from "./direct-sales-historic-client.page.vue?vue&type=style&index=0&id=57342dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57342dfe",
  null
  
)

export default component.exports